'use client';

import { useEffect } from 'react';
import { ViewTracking } from '@/utils/viewTracking';
export default function VisitorTracker() {
  useEffect(() => {
    ViewTracking.getVisitorId();
  }, []);
  return null;
}